exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2iiAYt1sBR0UDOk7ID79sO{border-radius:5px;margin-top:2px;overflow:hidden}._2iiAYt1sBR0UDOk7ID79sO li{background-color:#6293d6}._2iiAYt1sBR0UDOk7ID79sO li:nth-child(2n){background-color:#84b1e9}._2iiAYt1sBR0UDOk7ID79sO._1P0tORkPSfvn7oj__v_I_4 li{text-align:left;font-size:18px}._2iiAYt1sBR0UDOk7ID79sO._1P0tORkPSfvn7oj__v_I_4 li label{width:50%;background-color:rgba(74,101,166,.6);display:inline-block;text-align:right;margin-right:.5em;padding-right:.3em}", ""]);

// exports
exports.locals = {
	"list": "_2iiAYt1sBR0UDOk7ID79sO",
	"titles": "_1P0tORkPSfvn7oj__v_I_4"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Common/ColoredList/ColoredList.scss
 ** module id = 351
 ** module chunks = 0
 **/